<form [formGroup]="form">
  <div class="flex items-start gap-4">
    <mat-form-field class="flex-1">
      <mat-label>Practice</mat-label>
      <mat-select
        formControlName="practiceRef"
        [compareWith]="isSelectedPracticeRef"
        [required]="true"
      >
        @for (practice of practices$ | async; track practice.ref.path) {
          <mat-option [value]="practice.ref">{{ practice.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-1">
      <mat-label>Modality</mat-label>
      <mat-select formControlName="providerModality">
        @if (modality$ | async; as modality) {
          @for (item of modality.options; track item.value) {
            <mat-option [value]="item.value">
              {{ item.label }}
            </mat-option>
          }
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-1">
      <mat-label>Provider Number</mat-label>
      <input
        matInput
        formControlName="providerNumber"
        minlength="8"
        maxlength="8"
      />
      <mat-hint align="end">
        {{ form.value.providerNumber?.length || 0 }}/8 Characters
      </mat-hint>
      @if (
        form.controls.providerNumber | formControlError$: 'pattern' | async
      ) {
        <mat-error>Must not contain special characters</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="flex-1" floatLabel="always">
      <mat-label>Payee Provider Number</mat-label>
      <input
        matInput
        formControlName="payeeProviderNumber"
        placeholder="Pay the provider"
        minlength="8"
        maxlength="8"
      />
      @if (form.value.payeeProviderNumber) {
        <button
          type="button"
          mat-icon-button
          matIconSuffix
          matTooltip="Clear payee and pay the provider"
          aria-label="Clear payee provider number"
          (click)="clearPayeeProviderNumber()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      <mat-hint align="end">
        {{ form.value.payeeProviderNumber?.length || 0 }}/8 Characters
      </mat-hint>
      @if (
        form.controls.payeeProviderNumber | formControlError$: 'pattern' | async
      ) {
        <mat-error>Must not contain special characters</mat-error>
      }
      @if (
        form.controls.payeeProviderNumber
          | formControlError$: 'minlength'
          | async
      ) {
        <mat-error>Must be 8 characters, or left blank</mat-error>
      }
    </mat-form-field>

    <div matTextSuffix (click)="$event.stopImmediatePropagation()">
      <ng-content />
    </div>
  </div>
</form>
